import { Controller } from "web-ui/controller"
import { morphdomIgnore } from "web-ui/morphdom/ignore"
import * as Log from "web-ui/log"

// Connects to data-controller="character-counter"
export default class extends Controller {
  static targets = ["input", "counter"]

  static values = {
    maximum: Number
  }

  static events = {
    "input [data-character-counter-target~='input']": "update"
  }

  connect() {
    this.debug("Connect", { maximum: this.maximumValue })

    // A Turbo morph replaces the textarea's content without firing an input
    // event, which would leave the count stale. - Aaron, Sun Aug 23 2026
    this.observer = new MutationObserver(this.update)
    this.observer.observe(this.inputTarget, {
      attributes: true,
      attributeFilter: ["value"],
      characterData: true,
      childList: true,
      subtree: true
    })

    morphdomIgnore(this.counterTarget, true)

    this.update()
  }

  disconnect() {
    this.debug("Disconnect")

    morphdomIgnore(this.counterTarget, false)
  }

  update = () => {
    const count = this.inputTarget.value.length

    this.counterTarget.textContent = `${count}/${this.maximumValue}`
    this.counterTarget.classList.toggle("exceeds-maximum", count > this.maximumValue)
  }

  debug(message, data) {
    Log.debug("Character Counter - " + message, data)
  }
}
